import { getFormsServiceApiDomain } from '../../helpers';
export function trackEcommerceWidgetEvents(hashedDCK, vendorKey, payload = {}) {
	if (!hashedDCK || !vendorKey || !payload) {
		return false;
	}

	const URL = `${getFormsServiceApiDomain()}/leads/${hashedDCK}/widgets/${vendorKey}/events `;
	const request = new XMLHttpRequest();
	request.open('POST', URL);
	request.setRequestHeader('Content-Type', 'application/json');
	request.send(JSON.stringify(payload));

	request.addEventListener('error', function() {
		console.error('Something went wrong');
	});
}
